import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorOnboardingBody = dynamic(() => import('../../new-portal/ai-tutor/AITutorOnboarding'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const AITutorOnboardingActivity: ActivityComponentType = () => {
  return (
    <WebviewStackContainer height="0px" title={null} border={false}>
      <AITutorOnboardingBody />
    </WebviewStackContainer>
  )
}

export default AITutorOnboardingActivity
